import React from 'react'
import { ReactComponent as PersonCircle } from "../../assets/images/inbox/person-circle.svg";
import { ReactComponent as ArrowLeft } from "../../assets/images/inbox/arrow-left-circle.svg";
import "../../assets/scss/custom/inbox/SocialProfile.scss"
import { useDialogManager } from './helperHooks/HelperContext';
export default function SocialProfile() {
    const { setSelectedMember, userProfile, selectedChat } = useDialogManager();

    return (
        <div
            className="col-md-3 d-flex flex-column bg-white shadow-sm slide-in custom-sidebar" >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-2">
                <button className="btn btn-link p-0 text-dark" >
                    {selectedChat?.type === 2 ?
                        <ArrowLeft height={25} width={25} onClick={() => { setSelectedMember(null) }} />
                        : ""}
                </button>
                <h3 className="mb-0">Profile</h3>
                <span style={{ width: 20 }}></span>
            </div>

            {/* Profile + Details */}
            <div className="px-3 pt-3 pb-2" style={{ overflow: 'hidden', flex: 1 }}>
                {/* Profile */}
                <div className="text-center mb-3">
                    {userProfile?.profile_pic?.file?.url ? (
                        <img
                            src={userProfile.profile_pic.file.url}
                            alt="Profile"
                            className="rounded-circle img-fluid"
                            style={{ width: 70, height: 70 }}
                        />
                    ) : (
                        <PersonCircle width="70" height="70" fill="#75b35b" />
                    )}
                    <h5 className="my-2">{userProfile?.display_name}</h5>
                    <p className="text-muted mb-0">{userProfile?.email}</p>
                </div>

                {/* Scrollable Detail Section */}
                <div
                    className="border rounded p-3 bg-white shadow-sm scrollable-detail custom-scroll-area">
                    <div className="row mb-4">
                        <p className="profile-label">First Name</p>
                        <p className="profile-value mb-0">{userProfile?.first_name || "---"}</p>
                    </div>
                    <hr />

                    <div className="row mb-4">
                        <p className="profile-label">Last Name</p>
                        <p className="profile-value mb-0">{userProfile?.last_name || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Display Name</p>
                        <p className="profile-value mb-0">{userProfile?.display_name || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Display Email</p>
                        <p className="profile-value mb-0">{userProfile?.display_email || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Phone</p>
                        <p className="profile-value mb-0">{userProfile?.phone || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Company</p>
                        <p className="profile-value mb-0">{userProfile?.company || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Gender</p>
                        <p className="profile-value mb-0">{userProfile?.gender || "---"}</p>
                    </div>
                    <hr />
                    <div className="row mb-4">
                        <p className="profile-label">Birthday</p>
                        <p className="profile-value mb-0">{userProfile?.birthday || "---"}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
